"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteStatus = void 0;
var RouteStatus;
(function (RouteStatus) {
    RouteStatus["Success"] = "Success";
    RouteStatus["NoWay"] = "NoWay";
    RouteStatus["Partial"] = "Partial";
})(RouteStatus || (exports.RouteStatus = RouteStatus = {}));
